import React from 'react';
import { Link } from 'react-router-dom';

const CustomSlide2 = ({className = ''}) => {
    return (
        <section
            className={`ps-custom-slide2 ${className}`.trim()}
            aria-label="About Nature Way"
        >
            <div className="ps-custom-slide2__shell">
                <div className="ps-custom-slide2__content">
                    <div className="ps-custom-slide2__eyebrow">
                        <span className="ps-custom-slide2__leaf" aria-hidden="true">❧</span>
                        <span>Nature Way</span>
                    </div>

                    <h2 className="ps-custom-slide2__title">
                        Rooted in nature, <br />
                        made for <br />
                        healthy generations.
                    </h2>

                    <p className="ps-custom-slide2__copy">
                        At Nature Way, we harness the goodness of nature to create pure, wholesome products your family can trust.
                        From nutrient-rich staples to carefully crafted oils, everything we make is clean, honest, and free from harmful chemicals.
                    </p>

                    <p className="ps-custom-slide2__copy ps-custom-slide2__copy--strong">
                        We’re committed to your well-being today and a healthier tomorrow for generations to come.
                    </p>

                    <div className="ps-custom-slide2__note">
                        Better for you. Better for farmers. Better for our planet.
                    </div>

                    <Link className="ps-custom-slide2__button" to="/aboutus">
                        Who We Are
                    </Link>
                </div>

                <div className="ps-custom-slide2__visual" aria-hidden="true">
                    <div className="ps-custom-slide2__imageFrame">
                        <img src="/assets/img/custom_comp2_image.png" alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CustomSlide2;
